import { Chevron } from "client/components/icons/chevron";

const LeftSidebarHeader = ({
  open,
  setOpen,
  openIcon = <Chevron className="transform rotate-90" size={32} />,
  closedIcon = <Chevron className="transform -rotate-90" size={32} />,
  title = "Filters",
}: {
  open: boolean;
  setOpen: any;
  openIcon?: any;
  closedIcon?: any;
  title?: string;
}) => {
  return (
    <div className="flex items-center gap-3 h-12">
      <button
        onClick={() => setOpen((prev: boolean) => !prev)}
        className={`w-10 flex-shrink-0 h-10 transition-colors duration-300 ${
          open
            ? "bg-warmgrey-200 dark:bg-neutral-800"
            : "bg-white dark:bg-neutral-900"
        } flex flex-col justify-center hover:bg-neutral-200 dark:hover:bg-neutral-700 items-center rounded-full`}
      >
        {open ? <>{openIcon}</> : <>{closedIcon}</>}
      </button>

      <div
        className={`${
          open
            ? "opacity-100 visible delay-100 duration-300"
            : "opacity-0 invisible"
        } transition-all`}
      >
        <p>{title}</p>
      </div>
    </div>
  );
};

export default LeftSidebarHeader;
